import React from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-grid.css";
import { useState, useMemo, useEffect, useRef } from "react";
import PulseLoader from "../Utility/PulseLoader";
import CustomHeader from "../Utility/CustomHeader";
import ActionCellPrescription from "../Utility/ActionCellPescriptionintegration";
import ActionCellCompSecu from "../Utility/ActionCellCompSecu";
import ActionCellPurchasePharma from "../Utility/ActionCellPurchasePharma";
import {useLazyGetPurchaseDetailsQuery } from "../../State/Api/PharmacyOrderApiSlice";

ModuleRegistry.registerModules([AllCommunityModule]);

function Pharmacypurchasetable({ loading,purchaseData }) {

  console.log("purchaseData:", purchaseData);

  const pharmaid = localStorage.getItem("userUniqueID");
 

  const [rowData, setRowData] = useState(purchaseData  || []);
  const gridRef = useRef(null);

  useEffect(() => {
  if (purchaseData) {
    setRowData(purchaseData);
  }
}, [purchaseData]);


  const tableStyle = `
    /* Place your original CSS styles here unchanged */
    .focus\\:ring-\\[\\#00C335\\]:focus {
      --tw-ring-opacity: 1;
      --tw-ring-color: rgb(21 44 64 / 68%);
    }
    .btn-IdWmkZEQJd {
      border: none;
      background: #dcf2ff;
      color: #035ecf;
      width: 2.4rem;
      height: 2.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: .245rem;
      padding: .25rem .5rem;
    }
    .ag-horizontal-right-spacer.ag-scroller-corner {
      display: none !important;
    }
    .ag-header-viewport {
      overflow-x: hidden !important;
      will-change: auto !important;
    }
    .ag-theme-quartz .ag-row-selected::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background-color: #77c658;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      z-index: 1;
    }
    .ag-cell-value{
      border-left: unset !important;
      border-right: 1px solid #e5e5e5 !important;
    }
    .ag-column-first{
      border: unset !important;
    }
    .ag-theme-quartz .ag-row-selected::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background-color: #77c658;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      z-index: 1;
    }
    .ag-theme-quartz .ag-row-hover .ag-row-selected:hover {
      background-color: #f4fbf1 !important;
    }
    .ag-checkbox-input-wrapper::before,
    .ag-checkbox-input-wrapper::after {
      display: none;
    }
    .ag-ltr .ag-sort-indicator-icon {
      padding-left: var(--ag-grid-size);
      display: none;
    }
    .ag-header, .ag-advanced-filter-header {
      background-color: #A2AD91;
      border-bottom: var(--ag-borders-critical) var(--ag-border-color);
    }
    .ag-full-width-container {
      height : 100% !important;
    }
    .ag-header-cell-text {
      font-size: 0.9rem;
      text-transform: uppercase;
      color: #1e374f;
      font-weight: 600;
      font-family: 'Nunito', sans-serif !important;
    }
    .ag-header-cell-resize::after {
      background-color: #1991eb52;
    }
    .ag-ltr .ag-cell {
      text-align: center;
      display: flex;
      align-items: center;
    }
    .ag-header {
      border: none;
      padding: 0.5rem 0;
      min-height: 44px !important;
    }
    .ag-row {
      border: 1px solid #eeedf0;
    }
    .ag-row-odd {
      background-color: #fff !important;
    }
    .ag-row-even {
      background-color: #f7f7f7 !important;
    }
    .ag-root-wrapper {
      border: unset;
      background: transparent
    }
    .ag-body-viewport {
      border-top-left-radius: 5px !important;
      border-top-right-radius: 5px !important;
    }
    .ag-theme-quartz .ag-header-cell-filter-button {
      display: none;
    }
    .ag-header-cell-resize:after {
      background-color: #1991eb52;
      content: "";
      display: block;
      height: 30%;
      position: absolute;
      top: calc(50% - 30% * .5);
      z-index: 1;
    }
    .ag-cell, .ag-cell-not-inline-editing, .ag-cell-normal-height, .ag-cell-value, .ag-cell-focus {
      font-size: .9rem;
    }
    .ag-body-vertical-scroll {
      display : none;
    }
    .ag-header-cell-sortable .ag-header-cell-label {
      justify-content: start;
    }
    .ag-ltr .ag-cell {
      font-weight: 500 !important;
      letter-spacing: 0.5px;
      color: #2b2b2b !important;
    }
    .ag-header-cell-label {
      display: flex;
      justify-content: center;
    }
    .ag-cell:focus,
    .ag-cell-focus,
    .ag-row-focus {
      outline: none !important;
      border: none !important;
      box-shadow: none !important;
    }
  `;

  const getStableColor = (key) => {
    const bgColors = [
      "bg-danger bg-opacity-50",
      "bg-success bg-opacity-50",
      "bg-primary bg-opacity-50",
      "bg-warning bg-opacity-50",
    ];
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = key.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % bgColors.length;
    return bgColors[index];
  };

  useEffect(() => {
    if (!gridRef.current || !gridRef.current.api) return;
    const api = gridRef.current.api;
    if (loading) {
      api.showLoadingOverlay();
    } else if (!loading && rowData.length === 0) {
      api.showNoRowsOverlay();
    } else {
      api.hideOverlay();
    }
  }, [loading, rowData]);

  const [colDefs] = useState([
    
    {
      headerName: "INVOICE",
      field: "invoiceNum",
      width: 170,
      minWidth: 180,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        const name = params.value || "U";
        const initial = name.charAt(0).toUpperCase();
        const bgColor = getStableColor(name);
        return (
          <div className="d-flex align-items-center gap-2">
            {/* <div
              className={`d-flex justify-content-center align-items-center rounded-circle text-white fw-bold ${bgColor}`}
              style={{ width: "2rem", height: "2rem", fontSize: "0.875rem" }}
            >
              {initial}
            </div> */}
            <span className="text-secondary fw-medium small">{name}</span>
          </div>
        );
      },
    },
    {
  headerName: "TXN DATE",
  field: "invoiceDate",
  minWidth: 120,
  cellRenderer: (params) => {
    if (!params.value) return "-";

    const formattedDate = new Date(params.value)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-"); // "12 Dec 2025" -> "12-Dec-2025"

    return (
      <span className="text-secondary fw-medium small">
        {formattedDate}
      </span>
    );
  },
},

    {
      headerName: "INVOICE AMT",
      field: "totalAmount",
      minWidth: 120,
      cellRenderer: (params) => (
        <span className="text-secondary fw-medium small">{params.value}</span>
      ),
    },
    // {
    //   headerName: "ADJ AMT",
    //   field: "ADJAMT",
    //   minWidth: 120,
    //   cellRenderer: (params) => {
    //     const enabled = params.value;
    //     return (
    //       <span className="text-muted-foreground text-sm">{params.value}</span>
    //     );
    //   },
    // },

            {
      headerName: "PAID AMT",
      field: "paidAmount",
      minWidth: 130,
      cellRenderer: (params) => (
        <span className="text-secondary fw-medium small">{params.value}</span>
      ),
    },

    
    {
      headerName: "BALANCE AMT",
      field: "balanceAmount",
      minWidth: 130,
      cellRenderer: (params) => (
        <span className="text-secondary fw-medium small">{params.value}</span>
      ),
    },


    //  {
    //   headerName: "BALANCE",
    //   field: "BALANCE",
    //   minWidth: 180,
    //   cellRenderer: (params) => (
    //     <span className="text-muted-foreground text-sm">{params.value}</span>
    //   ),
    // },
    //  {
    //   headerName: "STATUS",
    //   field: "STATUS",
    //   minWidth: 180,
    //   cellRenderer: (params) => (
    //     <span className="text-muted-foreground text-sm">{params.value}</span>
    //   ),
    // },
    // {
    //   headerName: "REMARKS",
    //   field: "REMARKS",
    //   minWidth: 180,
    //   cellRenderer: (params) => (
    //     <span className="text-muted-foreground text-sm">{params.value}</span>
    //   ),
    // },
    {
      headerName: "Actions",
      field: "Actions",
      minWidth: 80,
     cellRenderer: (params) => (
  <ActionCellPurchasePharma
    purchaseId={params.data.purchaseId}
    pharmaId={pharmaid}
  />
),
    },
  ]);

  const autoSizeStrategy = {
    type: "fitGridWidth",
    columnLimits: [{ colId: "No of Team Members", minWidth: 900 }],
  };

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      sortable: true,
      enableRowGroup: true,
      sort: "asc",
      resizable: true,
      headerComponent: CustomHeader,
    };
  }, []);

  const CustomLoadingOverlay = () => (
    <div className="flex flex-col items-center justify-center h-full">
      <PulseLoader />
    </div>
  );

  const CustomNoRowsOverlay = () => (
    <div className="flex flex-col items-center justify-center h-full">
      <img
        src="/Images/doctortable.png"
        alt="No doctors available"
        className="w-64 h-64 object-contain mb-6"
      />
      <p className="text-gray-600 text-lg font-semibold">
        No Appointments Available
      </p>
    </div>
  );

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <div
        id="grid-wrapper"
        className="ag-theme-quartz custom-ag-grid"
        style={{
          width: "100%",
          height: "454px",
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
          borderRadius: "12px",
          backgroundColor: "#fff",
          minHeight: "32rem",
        }}
      >
        <style>{tableStyle}</style>
        <AgGridReact
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          rowClass="tbl-row-sc"
          ref={gridRef}
          loadingOverlayComponent={CustomLoadingOverlay}
          noRowsOverlayComponent={CustomNoRowsOverlay}
          rowHeight={40}
          headerHeight={30}
          autoSizeStrategy={autoSizeStrategy}
        />
      </div>
    </div>
  );
}

export default Pharmacypurchasetable;
